export default __webpack_public_path__ + "static/media/me.0c60c090.png";